import { useMemo } from 'react';
import { IOperationContext, TSlotContent } from '../type';
import { resolveConfigFunction } from '../utils/resolveConfigFunction';

export function useVisibleOperation(
  operation: TSlotContent | undefined,
  isNoData: boolean,
  isLoading: boolean,
  totalRecord: number,
): TSlotContent | undefined {
  return useMemo(() => {
    if (!Array.isArray(operation)) return operation;
    const context: IOperationContext = { isNoData, isLoading, totalRecord };
    return operation.filter((item) => {
      const showWhen = resolveConfigFunction<(context: IOperationContext) => boolean>(
        item.props?.showWhen,
      );
      if (!showWhen) return totalRecord > 0 && !isLoading;
      return showWhen(context);
    });
  }, [operation, isNoData, isLoading, totalRecord]);
}
